<template>
  <div class="form_con">
    <div class="fixed">
      <div class="top_header">
        <div class="m_flex_box flex_vc flex_jz">
          <div class="m_flex_box flex_vc">
            <van-icon
              name="arrow-left"
              class="mar_r"
              @click="goback"
              size="0.4rem"
            />
            <div class="search_con m_flex_box flex_vc">营业执照变更</div>
            <span class="saveDraft" @click="saveDraft"> 保存草稿 </span>
          </div>
        </div>
      </div>
    </div>
    <div class="fixed_pad"></div>
    <div style="padding: 0.1rem 0 0.1rem 0.5rem; background: #ccc">
      <van-icon name="fire-o" color="#ee0a24" />除标注选填外其他均为必填项
    </div>
    <van-form
      @submit="onSubmit"
      validate-trigger="onSubmit"
      :scroll-to-error="true"
    >
      <h5>
        委托书:(加盖公章的扫描件,jpg格式.写明某某公司委托某某办理入网手续,打印后加盖公章，扫描备用.)
      </h5>
      <div class="pic_con">
        <van-uploader :before-read="beforeRead" :after-read="afterReadEleven">
          <img
            :src="submitObj.trustImg"
            alt=""
            class="small"
            v-if="submitObj.trustImg"
          />
          <img :src="seatImg" alt="" class="small" v-else />
        </van-uploader>
      </div>
      <van-field
        v-model="submitObj.corpName"
        name="enterpriseName"
        type="text"
        label="企业名称:"
        placeholder="请输入企业名称"
        maxlength="10"
      />
      <van-field
        readonly
        clickable
        name="picker"
        :value="submitObj.corpNature"
        label="企业性质:"
        placeholder="点击选择企业性质"
        @click="naturePicker = true"
      />
      <van-popup v-model="naturePicker" position="bottom">
        <van-picker
          show-toolbar
          value-key="codeContent"
          :columns="natureList"
          @confirm="natureConfirm"
          @cancel="naturePicker = false"
        />
      </van-popup>
      <van-field
        v-model="submitObj.corpFund"
        type="text"
        label="注册资金:"
        placeholder="请输入注册资金"
      />
      <!-- <van-field
        readonly
        clickable
        name="picker"
        :value="submitObj.corpGrade"
        label="资质等级:"
        placeholder="点击选择资质"
        @click="gradePicker = true"
      />
      <van-popup v-model="gradePicker" position="bottom">
        <van-picker
          show-toolbar
          value-key="codeContent"
          :columns="gradeList"
          @confirm="gradeConfirm"
          @cancel="gradePicker = false"
        />
      </van-popup> -->
      <van-field
        v-model="submitObj.corpAddress"
        type="text"
        name="注册地址"
        label="注册地址:"
        placeholder="请输入注册地址"
      />
      <van-field
        v-model="submitObj.corpLegalName"
        type="text"
        name="法人姓名"
        label="法人姓名:"
        placeholder="请输入法人姓名"
      />
      <van-field
        v-model="submitObj.corpLegalPhone"
        type="text"
        name="法人电话"
        label="法人电话:"
        placeholder="请输入法人电话"
      />
      <h5>法人身份证复印件,正反同一张:(加盖公章后扫描,jpg):</h5>
      <div class="pic_con">
        <van-uploader :before-read="beforeRead" :after-read="afterReadOne">
          <img
            :src="submitObj.legalImg"
            alt=""
            class="small"
            v-if="submitObj.legalImg"
          />
          <img :src="seatImg" alt="" class="small" v-else />
        </van-uploader>
      </div>
      <van-field
        v-model="submitObj.license"
        name="certificateNumber"
        type="text"
        label="营业执照注册号:"
        placeholder="请输入注册号"
        maxlength="30"
      />
      <h5>营业执照有效期</h5>
      <van-field
        readonly
        clickable
        name="picker"
        :value="submitObj.licStartDate"
        value-key="text"
        label="开始时间:"
        placeholder="点击选择时间"
        @click="licenseStartShow = true"
      />
      <van-popup v-model="licenseStartShow" position="bottom">
        <van-datetime-picker
          v-model="currentDate"
          type="date"
          title="选择年月日"
          :min-date="startMinDate"
          :max-date="startMaxDate"
          @confirm="licenseStartConfirm"
          @cancel="licenseStartShow = false"
        />
      </van-popup>
      <van-field
        readonly
        clickable
        name="picker"
        :value="submitObj.licLimitDate"
        value-key="text"
        label="结束时间(选填):"
        placeholder="点击选择时间"
        @click="licenseEndShow = true"
      />
      <van-popup v-model="licenseEndShow" position="bottom">
        <van-datetime-picker
          v-model="currentDate"
          type="date"
          title="选择年月日"
          :min-date="endMinDate"
          :max-date="endMaxDate"
          @confirm="licenseEndConfirm"
          @cancel="licenseEndShow = false"
        />
      </van-popup>

      <h5>营业执照复印扫描件:(加盖公章,jpg格式)</h5>
      <div class="pic_con">
        <van-uploader :before-read="beforeRead" :after-read="afterReadTwo">
          <img
            :src="submitObj.licenseCopyImg"
            alt=""
            class="small"
            v-if="submitObj.licenseCopyImg"
          />
          <img :src="seatImg" alt="" class="small" v-else />
        </van-uploader>
      </div>

      <h5>营业执照原件的扫描件:(jpg格式)</h5>
      <div class="pic_con">
        <van-uploader :before-read="beforeRead" :after-read="afterReadThree">
          <img
            :src="submitObj.licenseImg"
            alt=""
            class="small"
            v-if="submitObj.licenseImg"
          />
          <img :src="seatImg" alt="" class="small" v-else />
        </van-uploader>
      </div>

      <van-cell-group>
        <van-field
          v-model="submitObj.remark"
          rows="3"
          autosize
          label="备注(选填):"
          type="textarea"
          placeholder="请输入备注"
          maxlength="50"
          show-word-limit
        />
      </van-cell-group>
      <van-field
        v-model="submitObj.state"
        label="审核状态:"
        type="text"
        v-if="applyId != ''"
      />
      <van-cell-group v-if="applyId != ''">
        <van-field
          readonly
          v-model="submitObj.rejectReason"
          rows="3"
          autosize
          label="未通过原因:"
          type="textarea"
          placeholder="无"
        />
      </van-cell-group>

      <div style="margin: 16px; padding-bottom: 16px">
        <van-button
          block
          type="info"
          native-type="submit"
          :disabled="isDisabled"
          >提交</van-button
        >
      </div>
    </van-form>
    <!-- <van-overlay
      :show="show"
      class="m_flex_box flex_hc flex_vc"
      @click="show = false"
    > -->
    <!-- <div class="wrap m_flex_box flex_vc flex_hc">
        <img src="@/assets/img/sfz_s.png" alt="" />
      </div>
    </van-overlay> -->
  </div>
</template>

<script>
import { Dialog } from "vant";
import qs from "qs";
export default {
  data() {
    return {
      isDisabled: false,
      submitObj: {
        corpCode: this.$route.query.corpCode || "",
        corpFund: "", //注册资金
        corpName: "", //企业名称
        corpNature: "", //企业性质
        corpAddress: "", //地址
        corpLegalName: "", //法人姓名
        corpLegalPhone: "", //法人电话
        legalImg: "", //法人身份证
        license: "", //营业证号
        certStartDate: "", //营业执照开始日期
        certLimitDate: "", //营业执照结束日期
        licenseImg: "", //营业执照证书扫描件
        licenseCopyImg: "", //营业执照证书复印件
        trustImg: "", //委托书
        process: "", //流程
        applyType: "2", //变更类型
        rejectReason: "", //驳回原因
        state: "", //审核状态
      },
      seatImg: require("@/assets/img/up.png"),
      startMinDate: new Date(1970, 1, 1),
      startMaxDate: new Date(),
      endMinDate: new Date(),
      endMaxDate: new Date(2100, 1, 1),
      currentDate: new Date(),
      natureList: [],
      gradeList: [],
      natureRole: "", //企业性质
      naturePicker: false,
      licenseStartShow: false,
      licenseEndShow: false,
      applyId: this.$route.query.applyId || "",
    };
  },
  components: {},
  mounted() {
    this.natureInit();
    // this.gradeInit();
    if (this.applyId != "") {
      this.infoInit();
    }
  },
  methods: {
    goback() {
      this.$router.go(-1);
    },
    afterReadOne(file) {
      this.createImage(file.file, "legalImg");
    },
    afterReadTwo(file) {
      this.createImage(file.file, "licenseCopyImg");
    },
    afterReadThree(file) {
      this.createImage(file.file, "licenseImg");
    },
    licenseStartConfirm(value) {
      this.submitObj.licStartDate = this.formatDateTime(value);
      this.licenseStartShow = false;
    },
    licenseEndConfirm(value) {
      this.submitObj.licLimitDate = this.formatDateTime(value);
      this.licenseEndShow = false;
    },
    //信息初始化
    infoInit() {
      this.$test
        .post(
          "spf/corpinfoapply/detail",
          qs.stringify({
            applyId: this.applyId,
          })
        )
        .then((res) => {
          if (res.code == "000") {
            var newObj = Object.assign(res.result, {});
            if (newObj.process == 1) {
              newObj.state = "草稿";
            } else if (newObj.process == 2) {
              newObj.state = "未通过";
            } else if (newObj.process == 3) {
              newObj.state = "未通过";
            } else if (newObj.process == 4) {
              newObj.state = "已通过";
            } else {
              newObj.state = "已归档";
            }
            this.submitObj = newObj;
          }
        });
    },
    //保存草稿
    saveDraft() {
      this.submitObj.process = "1";
      if (this.applyId == "") {
        this.$test
          .post("spf/corpinfoapply/add", qs.stringify(this.submitObj), {
            headers: {
              xzfpftoken: sessionStorage.getItem("userId") || "",
            },
          })
          .then((res) => {
            if (res.code == "000") {
              this.$router.replace({
                path: "/myManagement",
              });
            } else {
              this.$toast(res.msg);
            }
          });
      } else {
        this.$test
          .post("spf/corpinfoapply/update", qs.stringify(this.submitObj))
          .then((res) => {
            if (res.code == "000") {
              // this.$router.replace({
              //   path: "/myManagement",
              // });
              this.$router.go(-1);
            } else {
              this.$toast(res.msg);
            }
          });
      }
    },
    //企业性质初始化
    natureInit() {
      this.$test
        .post(
          "spf/codeinfo/getListByCode",
          qs.stringify({
            code: "01",
          })
        )
        .then((res) => {
          if (res.code == "000") {
            this.natureList = res.result;
          } else if (res.code == "003") {
            this.$toast(res.msg);
            this.$router.replace({
              path: "/enterpriseAccess",
            });
          } else {
            this.$toast(res.msg);
          }
        });
    },

    formatDateTime(date) {
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      return y + "-" + m + "-" + d;
    },
    natureConfirm(value) {
      this.submitObj.corpNature = value.codeContent;
      // this.natureId = value.codeInfoId;
      this.naturePicker = false;
    },

    beforeRead(file) {
      if (
        file.type.toLowerCase() !== "image/jpg" &&
        file.type.toLowerCase() !== "image/jpeg"
      ) {
        this.$toast("该格式不支持");
        return false;
      } else if (file.size > 3000 * 1024) {
        this.$toast("文件大小不得超过3M");
        return false;
      }
      return true;
    },
    //入网委托书
    afterReadEleven(file) {
      this.createImage(file.file, "trustImg");
    },
    onSubmit(values) {
      if (this.submitObj.corpName == "") {
        this.$toast("请填写企业名称");
        return;
      }
      if (this.submitObj.corpNature == "") {
        this.$toast("请填写企业性质");
        return;
      }
      if (this.submitObj.corpFund == "") {
        this.$toast("请填写注册资金");
        return;
      }
      if (this.submitObj.corpAddress == "") {
        this.$toast("请填写企业地址");
        return;
      }
      if (this.submitObj.corpLegalName == "") {
        this.$toast("请填写法人姓名");
        return;
      }

      if (this.submitObj.corpLegalPhone == "") {
        this.$toast("请填写法人电话");
        return;
      }
      if (this.submitObj.legalImg == "") {
        this.$toast("请上传法人身份证填写法人电话");
        return;
      }
      if (this.submitObj.license == "") {
        this.$toast("请填写营业证号");
        return;
      }

      if (this.submitObj.licStartDate == "") {
        this.$toast("请填写营业证开始日期");
        return;
      }

      if ((this.submitObj.certCopyImg = "")) {
        this.$toast("请上传营业执照证书复印件");
        return;
      }
      if ((this.submitObj.certImg = "")) {
        this.$toast("请上传营业执照证书扫描件");
        return;
      }
      this.isDisabled = true;
      this.submitObj.process = "2";
      if (this.applyId == "") {
        this.$test
          .post("spf/corpinfoapply/add", qs.stringify(this.submitObj))
          .then((res) => {
            this.$toast(res.msg);
            this.isDisabled = false;
            if (res.code == "000") {
              Dialog.alert({
                message:
                  "提交后1个工作日内将完成审核，如有疑问请拨打83601286进行咨询",
              }).then(() => {
                this.$router.replace({
                  path: "/myManagement",
                });
              });
            }
          })
          .catch(() => {
            this.isDisabled = false;
          });
      } else {
        this.$test
          .post("spf/corpinfoapply/update", qs.stringify(this.submitObj))
          .then((res) => {
            this.$toast(res.msg);
            this.isDisabled = false;
            if (res.code == "000") {
              // this.$router.replace({
              //   path: "/myManagement",
              // });
              this.$router.go(-1);
            }
          })
          .catch(() => {
            this.isDisabled = false;
          });
      }
    },
    createImage(file, name) {
      let reader = new FileReader();
      let self = this;
      reader.onload = (e) => {
        let result = e.target.result;
        let img = new Image();
        img.src = result;
        if (result.length / 1024 > 30) {
          img.onload = function () {
            //0.6为压缩的程度，数值越小，压缩的文件越小，图片也会越模糊
            // this.firImg = self.compress(img, 0.4)
            self.submitObj[name] = self.compress(img, 0.9);
          };
        } else {
          self.submitObj[name] = result;
        }
      };
      // 读取图像
      reader.readAsDataURL(file);
    },
    //图片压缩
    compress(img, size) {
      let canvas = document.createElement("canvas");
      let ctx = canvas.getContext("2d");
      if (img.width > 1200 && img.width >= img.height) {
        img.height *= 1200 / img.width;
        img.width = 1200;
      }
      //宽小于高的情况
      if (img.height > 1200 && img.height > img.width) {
        img.width *= 1200 / img.height;
        img.height = 1200;
      }
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      //绘制图片
      ctx.drawImage(img, 0, 0, img.width, img.height);
      //进行最小压缩
      let ndata = canvas.toDataURL("image/jpeg", size);
      return ndata;
    },
  },
};
</script>
<style lang="less" scoped>
.fixed_pad {
  padding-top: 1.1rem;
}
.bg_gray {
  min-height: 100vh;
  background-color: #ffffff;
}
.fixed {
  border-bottom: 1px solid #f5f5f5;
  background-color: #fff;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  z-index: 9;
  .top_normal {
    height: 100%;
    i {
      font-size: 0.32rem;
    }
  }
}
.top_header {
  height: 0.7rem;
  padding: 0.1rem 0rem;
  width: 7.04rem;
  margin: 0 auto;
  &.top_sm {
    padding: 0.1rem;
  }
  .search_con,
  .search_con_l {
    height: 0.7rem;
    box-sizing: border-box;
    font-size: 0.3rem;
    padding: 0 0.3rem;
    color: #303030;
    i {
      font-size: 0.36rem;
      margin-right: 0.2rem;
    }
  }
  input {
    width: 80%;
    height: 0.7rem;
    background-color: transparent;
  }
  .search_con {
    font-weight: bolder;
    justify-content: center;
    width: 5.78rem;
  }
  .search_con_l {
    width: 5.72rem;
  }
  .to_map {
    font-size: 0.28rem;
    img {
      margin-right: 0.06rem;
      width: 0.32rem;
      height: 0.32rem;
    }
  }
}
.form_con {
  // padding: 0.3rem 0rem;
  .newlyAdded {
    position: relative;
    h3 {
      line-height: 1rem;
      font-size: 0.36rem;
      font-weight: 800;
    }
  }
  .saveDraft {
    padding: 0.1rem 0.15rem;
    font-size: 0.2rem;
    border-radius: 0.1rem;
    border: 1px solid #007fff;
    color: #007fff;
    position: absolute;
    right: 0.2rem;
    top: 50%;
    transform: translateY(-50%);
  }
  /deep/ .b_f {
    line-height: 32px;
  }
}
h5 {
  font-size: 14px;
  padding: 10px 16px 0;
  color: #646566;
}
.pic_con {
  padding: 16px 16px;
  position: relative;
  .small {
    width: 2.56rem;
    height: 1.63rem;
  }
  .big {
    width: 2.18rem;
    height: 3.4rem;
  }
  p {
    color: #474747;
    font-size: 12px;
    width: 2.56rem;
    text-align: center;
    margin-top: 0.1rem;
    color: #666;
  }
  &:after {
    position: absolute;
    box-sizing: border-box;
    content: " ";
    pointer-events: none;
    right: 16px;
    bottom: 0;
    left: 16px;
    border-bottom: 1px solid #ebedf0;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
  }
}
.col_blue {
  color: #2f72f5;
  font-size: 0.26rem;
}
.wrap {
  background-color: #fff;
  width: 5.8rem;
  height: 7.84rem;
  border-radius: 0.02rem;
  img {
    width: 4.04rem;
    height: 6.28rem;
  }
}
</style>